import React from "react";
import Box from "@mui/material/Box";

import { Text } from "merchant-portal-common/Text";

export enum MessageBoxSize {
	Large = "Large",
	Small = "Small",
}

export type MessageType = string[] | JSX.Element;

export interface MessageBoxProps {
	title: string;
	size: MessageBoxSize;
	message: MessageType;
	icon?: JSX.Element;
	testId?: string;
}

export const MessageBox: React.FC<MessageBoxProps> = ({ title, size, message, icon, testId }) => {
	const isMessageArray = Array.isArray(message);

	return (
		<Box
			data-testid={testId || "message-box-wrapper"}
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				textAlign: "center",
			}}
		>
			<Text
				testId="message-box-title"
				type="h1"
				bold
				customOverride={{
					margin: "unset",
					mb: "1rem",
					fontSize: () => {
						switch (size) {
							case MessageBoxSize.Large:
								return "3rem";
							case MessageBoxSize.Small:
							default:
								return "2rem";
						}
					},
					lineHeight: () => {
						switch (size) {
							case MessageBoxSize.Large:
								return "4rem";
							case MessageBoxSize.Small:
							default:
								return "2.7rem";
						}
					},
				}}
			>
				{title}
			</Text>
			{isMessageArray
				? message.map((line) => (
						<Text
							testId="message-box-text"
							type="h3"
							bold
							customOverride={{
								margin: "unset",
								fontSize: () => {
									switch (size) {
										case MessageBoxSize.Large:
											return "2.4rem";
										case MessageBoxSize.Small:
										default:
											return "1.6rem";
									}
								},
								lineHeight: () => {
									switch (size) {
										case MessageBoxSize.Large:
											return "3.2rem";
										case MessageBoxSize.Small:
										default:
											return "2.2rem";
									}
								},
							}}
							key={line}
						>
							{line}
						</Text>
					))
				: message}
			{icon && <Box sx={{ "mt": "3rem", "& svg": { mr: "0 !important" } }}>{icon}</Box>}
		</Box>
	);
};
